module.exports = __webpack_public_path__ + "static/media/b-icon-gray.69841e9f.svg";